class FetchBeneficiaryAccess {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchBeneficiaryAccess;
